import Box from 'UIKit/Box/Box'
import Text from 'UIKit/Text/Text'
import { RouteConfig } from 'config/constants/route'
import { ActionQueryEnum } from 'hooks/useActionQueryListener'
import useModal from 'hooks/useModal'
import { useTranslation } from 'react-i18next'
import { useLogout } from 'state/auth/hooks'
import { useToggleDisplayNotification, useUnreadNotificationAmount } from 'state/notification/hooks'
import styled from 'styled-components'
import { Icons } from 'svgs'
import { colors } from 'theme/colors'
import HUSDUnlock from 'views/HUSDUnlock'
import { RowMiddle } from '../Row'
import UserMenuAchor from './UserMenuAnchor'
import UserMenuDropdownItem from './UserMenuDropdownItem'

const UserMenuDropdown: React.FC<{ onDismiss?: () => void }> = ({ onDismiss }) => {
  const { t } = useTranslation()
  const logout = useLogout()
  const [onPresentHUSDModal] = useModal(HUSDUnlock)

  const { toggle: updateDisplayNotification } = useToggleDisplayNotification()
  const { unreadAmount } = useUnreadNotificationAmount()

  return (
    <StyledMenuDropdownContainer id="usermenu-dropdown">
      <Box px="5px" id="user-profile" onClick={() => onDismiss()}>
        <UserMenuAchor />
      </Box>
      <Box background={colors.stroke} height="0.75px" width="90%" margin="10px auto" />

      <StyledUserMenuDropdownItem
        id="husdunclock"
        Icon={<Icons.HusdIcon />}
        content={t('HUSD Rakeback')}
        onDismiss={onDismiss}
        linkTo={''}
        onClick={() => onPresentHUSDModal()}
      />
      <StyledUserMenuDropdownItem
        id="usermenu-cashback"
        Icon={<Icons.CashbackIcon stroke={colors.text} path={colors.text} />}
        content={t('Cashback')}
        onDismiss={onDismiss}
        linkTo={RouteConfig.Cashback}
      />

      <StyledUserMenuDropdownItem
        id="usermenu-referral"
        Icon={<Icons.ReferralIcon fill={colors.text} />}
        content={t('Referral')}
        onDismiss={onDismiss}
        linkTo={RouteConfig.Referral}
      />

      <StyledUserMenuDropdownItem
        id="usermenu-transaction"
        Icon={<Icons.TransactionHistoryIcon fill={colors.text} />}
        content={t('Transaction History')}
        onDismiss={onDismiss}
        linkTo={RouteConfig.DepositTransactionHistory}
      />

      <RowMiddle display={['flex !important', 'flex !important', 'flex !important', 'none !important']}>
        <StyledMenuDropdownNotification
          id="notification"
          Icon={<Icons.NotificationIcon />}
          content={t('Notification')}
          display={['block', 'none']}
          linkTo={''}
          onClick={() => {
            updateDisplayNotification(true)
          }}
          onDismiss={onDismiss}
        />

        <StyledUnreadAmountBadge display={unreadAmount > 0 ? 'block' : 'none'}>
          <Text fontSize="12px" bold>
            {unreadAmount}
          </Text>
        </StyledUnreadAmountBadge>
      </RowMiddle>

      <StyledUserMenuDropdownItem
        id="usermenu-referral"
        Icon={<Icons.SupportIcon fill={colors.text} />}
        content={t('Support')}
        onDismiss={onDismiss}
        linkTo={`?action=${ActionQueryEnum.OpenSupportChat}`}
      />

      <StyledUserMenuDropdownItem
        id="logout"
        Icon={<Icons.LogoutIcon />}
        content={t('Logout')}
        onDismiss={onDismiss}
        linkTo={''}
        onClick={logout}
      />
    </StyledMenuDropdownContainer>
  )
}

const StyledUserMenuDropdownItem = styled(UserMenuDropdownItem)`
  padding: 6px 12px;
  cursor: pointer;
  border-radius: ${({ theme }) => theme.radii.tiny};
  width: 100%;
  ${({ theme }) => theme.mediaQueries.lg} {
    &:hover {
      background: ${({ theme: { colors } }) => colors.backgroundAlt4};
    }
  }
`

const StyledUnreadAmountBadge = styled(Box)`
  border-radius: ${({ theme: { radii } }) => radii.small};
  background: ${({ theme: { colors } }) => colors.strokeAlt3};
  max-height: 40px;
  padding: 2px 6px;
`

const StyledMenuDropdownNotification = styled(StyledUserMenuDropdownItem)`
  svg {
    path {
      fill: ${({ theme: { colors } }) => colors.text};
    }
  }
`

const StyledMenuDropdownContainer = styled(Box)`
  background: ${({ theme: { colors } }) => colors.inputBlur};
  backdrop-filter: blur(15px);

  padding: 12px 7.5px;

  border-radius: ${({ theme: { radii } }) => radii.small};
`

export default UserMenuDropdown
